import { CloudDownload, Code2, Droplets, Mail } from "lucide-react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSubMenu } from "../../../../empreenderUI/SubMenuContext";
import { translations } from "../../../../utils/language";
import PersonalizarModule from "./PersonalizarModule";
import { isNuvemshopPlatform, PERSONALIZAR_CONTENT_TO_ROUTE } from "./routeMap";

const PersonalizarMenu = () => {
	const { toggle } = useSubMenu();
	const history = useHistory();
	const language = useSelector((state) => state.reducerLanguage);

	const modules = [
		{
			name: "checkout",
			title: translations["thema-checkout"]?.[language.data] || "Checkout",
			icon: <CloudDownload size={18} color="#111827" />,
			visible: true,
		},
		{
			name: "page-checkout",
			title: translations["sidebar-pagina-downloads"]?.[language.data] || "Página de downloads",
			icon: <Code2 size={18} color="#111827" />,
			visible: isNuvemshopPlatform(),
		},
		{
			name: "email",
			title: translations["sidebar-email"]?.[language.data] || "E-mail",
			icon: <Mail size={18} color="#111827" />,
			visible: true,
		},
		{
			name: "marca-agua",
			title: translations["marca-agua"]?.[language.data] || "Marca d'água",
			icon: <Droplets size={18} color="#111827" />,
			visible: true,
			isNew: true,
		},
	];

	const handleOpen = (name) => {
		const route = PERSONALIZAR_CONTENT_TO_ROUTE[name];
		if (route) history.push(route);
		toggle(name);
	};

	return (
		<div className="flex flex-col gap-2 relative w-full h-full px-[10px] pt-6">
			{modules
				.filter((item) => item.visible)
				.map((item) => (
					<PersonalizarModule
						key={item.name}
						name={item.name}
						title={item.title}
						icon={item.icon}
						isNew={item.isNew}
						onOpen={handleOpen}
					/>
				))}
		</div>
	);
};

export default PersonalizarMenu;
